import { useEffect } from 'react'
import { useAuth } from '../AuthProvider'
import { Spinner, SpinnerSize, Stack } from '@fluentui/react'

const LogoutCallbackComponent = () => {
  const { userManager } = useAuth()

  useEffect(() => {
    userManager
      .signoutRedirectCallback()
      .then(() => {
        localStorage.clear()
        window.location.href = '/'
      })
      .catch((error) => {
        console.error('Error completing logout:', error)
        localStorage.clear()
        window.location.href = '/'
      })
  }, [userManager])

  return (
    <Stack verticalAlign="center" horizontalAlign="center" styles={{ root: { height: '100vh' } }}>
      <Spinner size={SpinnerSize.large} label="Logging out..." />
    </Stack>
  )
}

export default LogoutCallbackComponent
